import React from "react";

import {
    Navigate,
    Outlet,
    useLocation
} from "react-router-dom";

const getDefaultPathForRole = (role) => {
    const r = role == null ? null : String(role);
    if (r === "1") return `/super-admin`;
    if (r === "2") return `/auditor/dashboard`;
    if (r === "3") return `/compliancer/dashboard`;
    if (r === "4") return `/approver/dashboard`;
    return `/sign-in`;
};

const useAuth = () => {
    const rawUser = localStorage.getItem("user");
    if (!rawUser) return { auth: false, role: null };

    try {
        const user = JSON.parse(rawUser);
        const role = user?.role_id ?? user?.roleId ?? null;
        return { auth: true, role };
    } catch (_e) {
        return { auth: false, role: null };
    }
}

const ProtectedRoutes = (props) => {
    const location = useLocation();
    const {
        auth,
        role
    } = useAuth()

    const normalizedRole = role == null ? null : String(role);
    const requiredRole = props.roleRequired == null ? null : String(props.roleRequired);

    if (props.roleRequired) {
        if (!auth) {
            return (
                <Navigate
                    to={`sign-in`}
                    replace
                    state={{ from: location.pathname }}
                />
            );
        }

        return requiredRole === normalizedRole ? (
            <Outlet />
        ) : (
            <Navigate to={getDefaultPathForRole(normalizedRole)} replace />
        );
    } else {
        return auth ? (
            <Outlet />
        ) : (
            <Navigate
                to={`sign-in`}
                replace
                state={{ from: location.pathname }}
            />
        );
    }




}

export default ProtectedRoutes;